import { useEffect } from "react";
import { useAppSelector } from "@/store/hooks";
import i18n from "@/i18n/config";
export const I18nSync = ({ children }: { children: React.ReactNode }) => {
  const language = useAppSelector((state) => state.preferences.language);

  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return <>{children}</>;
};
